import { type PracticeMigrationEssentials } from '@principle-theorem/practice-migrations/interfaces';
import { PRACTICE_WORKS_DESTINATION } from './destination';
import { PRACTICE_WORKS_MAPPINGS } from './mappings';
import { PRACTICE_WORKS_SOURCE } from './source';

export const PRACTICE_WORKS_MIGRATION: PracticeMigrationEssentials = {
  metadata: {
    name: 'Practice Works',
    version: 'v1',
    supportsMultiplePractices: false,
  },
  source: PRACTICE_WORKS_SOURCE,
  destination: PRACTICE_WORKS_DESTINATION,
  mappings: PRACTICE_WORKS_MAPPINGS,
};
